@if (taskApi) {
  <div>
    <mat-card style="background-color: lightyellow">
      <mat-card-content>
        <table style="white-space: nowrap">
          <tr>
            <td colspan="2">
              <h1>Summary</h1>
            </td>
          </tr>
          @if (taskApi.name !== undefined) {
            <tr>
              <td>Name:</td>
              <td>{{taskApi.name}}</td>
            </tr>
          }
          @if (taskId !== undefined) {
            <tr>
              <td>Task Id:</td>
              <td>{{taskId}}</td>
            </tr>
          }
          @if (taskApi !== undefined  && taskApi.createdBy !== undefined) {
            <tr>
              <td>Created:</td>
              <td>{{taskApi.dateCreated | date:'short' }}</td>
            </tr>
          }
          @if (taskApi !== undefined  && taskApi.dateStart !== undefined) {
            <tr>
              <td>Begin:</td>
              <td>{{taskApi.dateStart | date:'short' }}</td>
            </tr>
          }
          @if (taskApi !== undefined  && taskApi.dateEnd !== undefined) {
            <tr>
              <td>End:</td>
              <td>{{taskApi.dateEnd | date:'short' }}</td>
            </tr>
          }
          @if (taskApi !== undefined  && taskApi.dateLastUpdated !== undefined) {
            <tr>
              <td>Last Updated:</td>
              <td>{{taskApi.dateLastUpdated | date:'short' }}</td>
            </tr>
          }
          @if (taskApi !== undefined  && taskApi.assignedTo !== undefined) {
            <tr>
              <td>Assigned:</td>
              <td>{{taskApi.dateAssigned | date:'short' }}</td>
            </tr>
          }
          <tr>
            <td>miniDoc: </td>
            <td>
              @if (taskApi.miniDoc&&taskApi.miniDoc.length>0) {
                <span>
                  Yes
                </span>
              } @else {
                No
              }
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <br>
                <h2>People</h2>
              </td>
            </tr>
            @if (taskApi && taskApi.team) {
              <tr>
                <td>Team assigned:</td>
                <td>{{taskApi.team.name}}</td>
              </tr>
            }
            @if (taskApi && taskApi.assignedTo) {
              <tr>
                <td>Assigned to:</td>
                <td>{{taskApi.assignedTo.firstName}} {{taskApi.assignedTo.lastName}}</td>
              </tr>
            }
            @if (taskApi && taskApi.createdBy) {
              <tr>
                <td>Created by:</td>
                <td>{{taskApi.createdBy.firstName}} {{taskApi.createdBy.lastName}}</td>
              </tr>
            }
            @if (taskApi && taskApi.ownedBy) {
              <tr>
                <td>Owned by:</td>
                <td>{{taskApi.ownedBy.firstName}} {{taskApi.ownedBy.lastName}}</td>
              </tr>
            }
            <tr>
              <td colspan="2">
                <br>
                  <h2>Categories</h2>
                </td>
              </tr>
              @if (taskApi.tags) {
                <tr>
                  <td style="vertical-align: top">Tags:</td>
                  <td>
                    @for (tag of taskApi.tags; track tag) {
                      <span style="background-color: lightcyan">{{tag.name}}<br></span>
                    }
                  </td>
                </tr>
              }
              @if (taskApi.folder) {
                <tr>
                  <td>Folder:</td>
                  <td>{{taskApi.folder.name}}</td>
                </tr>
              }
              @if (taskApi.context) {
                <tr>
                  <td>Context:</td>
                  <td>{{taskApi.context.name}}</td>
                </tr>
              }
              @if (taskApi.goal) {
                <tr>
                  <td>Goal:</td>
                  <td>{{taskApi.goal.name}}</td>
                </tr>
              }
              @if (taskApi.project) {
                <tr>
                  <td>Project:</td>
                  <td>{{taskApi.project.name}}</td>
                </tr>
              }
              @if (taskApi.phase) {
                <tr>
                  <td>Phase:</td>
                  <td>{{taskApi.phase.name}}</td>
                </tr>
              }
              @if (taskApi.process) {
                <tr>
                  <td>Process:</td>
                  <td>{{taskApi.process.name}}</td>
                </tr>
              }
            </table>
          </mat-card-content>
        </mat-card>
      </div>
    }
